export const handleClickScroll = (scrollToItem) => {
  const element = document.getElementById(`${scrollToItem}`);

  if (element) {
    // 👇 Will scroll smoothly to the top of the next section
    element.scrollIntoView({ behavior: "smooth" });
  }
};
